import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=023da767&scoped=true&"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=ts&"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSnackbar.vue?vue&type=style&index=0&id=023da767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023da767",
  null
  
)

export default component.exports